import { AxiosInstance, AxiosPromise } from 'axios';

import {
  JobFinanceServicesEndpoint,
  JobFinanceServices,
  OfferServices,
  OfferServicesEndpoint,
} from './services';

import {
  JobEndpoint,
  RemoveHoldResponse,
  getCarrierResponse,
  UpdateStopStatusParam,
  UpdateStopStatusResponse,
  GetRateConfirmationResponse,
  DocumentRequest,
  CreateJobCaseRequest,
  CreateJobCaseResponse,
  GetJobCasesRequest,
  GetJobCasesResponse,
  SetAsTONURequest,
  SetAsTONUResponse,
  UpdateJobDistanceRequest,
  ResolveJobCaseRequest,
  ResolveJobCaseResponse,
  UnResolveJobCaseRequest,
  UnResolveJobCaseResponse,
  DeleteJobCaseRequest,
  DeleteJobCaseResponse,
} from './JobServices.types';

export class JobServices implements JobEndpoint {
  instance: AxiosInstance;
  finance: JobFinanceServicesEndpoint;
  offer: OfferServicesEndpoint;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.finance = new JobFinanceServices(instance);
    this.offer = new OfferServices(instance);
  }

  addHold(jobGuid: string): AxiosPromise<void> {
    return this.instance.post(`/job/${jobGuid}/hold`);
  }

  removeHold(jobGuid: string): AxiosPromise<RemoveHoldResponse> {
    return this.instance.delete(`/job/${jobGuid}/hold`);
  }

  setToReady(jobGuid: string): AxiosPromise<void> {
    return this.instance.put(`/job/${jobGuid}/ready`);
  }

  getCarrier(jobGuid: string): AxiosPromise<getCarrierResponse> {
    return this.instance.get(`/job/${jobGuid}/dispatch/carrier`);
  }

  delete(jobGuid: string): AxiosPromise<void> {
    return this.instance.delete(`/job/${jobGuid}`);
  }

  unDelete(jobGuid: string): AxiosPromise<void> {
    return this.instance.put(`/job/${jobGuid}/undelete`);
  }

  cancel(jobGuid: string): AxiosPromise<void> {
    return this.instance.put(`/job/${jobGuid}/cancel`);
  }

  unCancel(jobGuid: string): AxiosPromise<void> {
    return this.instance.put(`/job/${jobGuid}/uncancel`);
  }

  updateStopStatus({
    jobGuid,
    stopGuid,
    status,
    commodities,
    date,
  }: UpdateStopStatusParam): AxiosPromise<UpdateStopStatusResponse> {
    return this.instance.put(`/job/${jobGuid}/stop/${stopGuid}/status/${status}`, {
      commodities,
      date,
    });
  }

  getRateConfirmation(params: DocumentRequest): AxiosPromise<GetRateConfirmationResponse> {
    return this.instance.get(`/job/${params.routeParams.jobGuid}/doc/rate-confirmation`);
  }

  getBolDocument(params: DocumentRequest) {
    return this.instance.get(`/job/${params.routeParams.jobGuid}/doc/carrier-bol`);
  }

  createJobCase(params: CreateJobCaseRequest): AxiosPromise<CreateJobCaseResponse> {
    return this.instance.post(`/job/${params.queryParams.jobGuid}/case`, params.body);
  }

  getCases(params: GetJobCasesRequest): AxiosPromise<GetJobCasesResponse> {
    return this.instance.get(`/job/${params.routeParams.jobGuid}/cases`);
  }

  resolveCase(request: ResolveJobCaseRequest): AxiosPromise<ResolveJobCaseResponse> {
    return this.instance.put(`/case/${request.routeParams.guid}/resolve`);
  }

  unResolveCase(request: UnResolveJobCaseRequest): AxiosPromise<UnResolveJobCaseResponse> {
    return this.instance.put(`/case/${request.routeParams.guid}/unresolve`);
  }

  deleteCase(request: DeleteJobCaseRequest): AxiosPromise<DeleteJobCaseResponse> {
    return this.instance.delete(`/case/${request.routeParams.guid}`);
  }

  setAsTONU(request: SetAsTONURequest): AxiosPromise<SetAsTONUResponse> {
    return this.instance.put(`/job/${request.routeParams.jobGuid}/tonu`, request.body);
  }

  updateDistance(request: UpdateJobDistanceRequest): AxiosPromise<void> {
    return this.instance.put(`/job/${request.routeParams.jobGuid}/distance`, request.body);
  }
}
